function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const d = new Date();
    d.setTime(d.getTime() + days*24*60*60*1000);
    expires = "; expires=" + d.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function updateWishlistHeader(wishlist) {
  const header = document.querySelector(".ms-wishlist-header");
  const countSpan = header?.querySelector("span");
  if (header && countSpan) {
    countSpan.textContent = wishlist.length;
    if (wishlist.length > 0) {
      header.classList.add("active");
    } else {
      header.classList.remove("active");
    }
  }
}
function updateHearts(wishlist) {
  document.querySelectorAll(".wishlist-heart").forEach(heart => {
    const productId = heart.dataset.productId;
    if (wishlist.includes(productId)) {
      heart.classList.add("active");
    } else {
      heart.classList.remove("active");
    }
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const wishlistCookie = getCookie("wishlist") || "";
  const wishlist = wishlistCookie ? wishlistCookie.split(",") : [];
  updateHearts(wishlist);
  updateWishlistHeader(wishlist);
  document.addEventListener("click", function (e) {
    const heart = e.target.closest(".wishlist-heart");
    if (!heart) return;
    const productId = heart.dataset.productId;
    const index = wishlist.indexOf(productId);
    if (index > -1) {
      wishlist.splice(index, 1);
      heart.classList.remove("active");
    } else {
      wishlist.push(productId);
      heart.classList.add("active");
    }
    setCookie("wishlist", wishlist.join(","), 30);
    updateWishlistHeader(wishlist);
  });
});